"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJobRun = exports.useLoadExternalJob = void 0;
var react_redux_1 = require("react-redux");
var job_1 = require("remota-client/page/hook/job");
var module_1 = require("app/module");
// ================================================================
// Job
var useLoadExternalJob = function (id) {
    var state = (0, react_redux_1.useSelector)(function (state) { return [state.multi.job, state.loading]; });
    return (0, job_1.useLoadExternalJobBase)(module_1.OutsideModule.JOB, state, id);
};
exports.useLoadExternalJob = useLoadExternalJob;
var useJobRun = function (isExternal) {
    var state = (0, react_redux_1.useSelector)(function (state) { return state.loading; });
    return (0, job_1.useJobRunBase)(state, isExternal);
};
exports.useJobRun = useJobRun;
